import { FC } from "react";
import ActionButtons from "../../../../components/ActionButtons/ActionButtons";
import "./MessageBoxLayoutContent.scss";
import { PropsMessageBoxLayoutContent } from "../../modelsMessageBox";

const MessageBoxLayoutContent: FC<PropsMessageBoxLayoutContent> = ({
    actionButtons = [],
    textContent,
    stateWindow,
}) => {
    return (
        <div className="message_box__content">
            <main className="message_box__content_main">
                {textContent.title && (
                    <h1
                        state-window={stateWindow}
                        className="message_box__content_main_title"
                        offset-bottom={String(textContent.text ? true : false)}
                    >
                        {textContent.title}
                    </h1>
                )}

                {textContent.text && (
                    <h2 className="message_box__content_main_text">
                        {textContent.text}
                    </h2>
                )}
            </main>

            <ActionButtons
                actionButtons={actionButtons}
                offsetBottom={24}
                position="bottom_center"
            />
        </div>
    );
};

export default MessageBoxLayoutContent;
